import apiRepository from "Repositories/apiRepository";

export const ProductService = {
    async getBySupplier(supplierId, limit, page) {
        try {
            const response = await apiRepository.get(
                `/suppliers/${supplierId}/products?limit=${limit}&page=${page}`
            );
            return response.data;
        } catch (err) {
            // TODO: error handling
            return {
                data: [],
                total: 0,
            };
        }
    },
    async getAll() {
        try {
            // const response = await apiRepository.get('/suppliers/-/products');

            // hardcode only get single supplier for dev
            const response = await apiRepository.get("/suppliers/-/products");
            return response.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async getAllPaginated(limit, page) {
        try {
            // const response = await apiRepository.get('/suppliers/-/products');

            // hardcode only get single supplier for dev
            const response = await apiRepository.get(
                `/suppliers/-/products?limit=${limit}&page=${page}`
            );
            return response.data;
        } catch (err) {
            // TODO: error handling
            return {
                data: [],
                total: 0,
            };
        }
    },

    async searchBySupplier(supplierId, query, limit, page) {
        try {
            const response = await apiRepository.get(
                `/suppliers/${supplierId}/products?query=${query}&limit=${limit}&page=${page}`
            );
            return response.data;
        } catch (err) {
            // TODO: error handling
            return {
                data: [],
                total: 0,
            };
        }
    },

    async searchAll(query, limit, page) {
        try {
            const response = await apiRepository.get(
                `/suppliers/-/products?query=${query}&limit=${limit}&page=${page}`
            );
            return response.data;
        } catch (err) {
            // TODO: error handling
            return {
                data: [],
                total: 0,
            };
        }
    },

    async create(product, supplierId) {
        try {
            const response = await apiRepository.post(
                `/suppliers/${supplierId}/products`,
                { ...product }
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async update(product, supplierId) {
        try {
            const response = await apiRepository.post(
                `/suppliers/${supplierId}/products/${product._id}`,
                product
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async deleteById(productId, supplierId) {
        try {
            const response = await apiRepository.delete(
                `/suppliers/${supplierId}/products/${productId}`
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async delete(product, supplierId) {
        try {
            const response = await apiRepository.delete(
                `/suppliers/${supplierId}/products/${product._id}`
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async deleteAll(supplierId) {
        try {
            const response = await apiRepository.delete(
                `/suppliers/${supplierId}/products`
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },

    async importProductsForSupplier(supplierId, products) {
        try {
            const response = await apiRepository.post(
                `/suppliers/${supplierId}/products/import`,
                { products: [...products] }
            );
            return response.data.data;
        } catch (err) {
            // TODO: error handling
        }
    },
};
